import React, { useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
interface NameScreenProps {
  onSubmit: (name: string) => void;
}
export const NameScreen: React.FC<NameScreenProps> = ({
  onSubmit
}) => {
  const [name, setName] = useState('');
  const [error, setError] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (name.trim().length < 2) {
      setError(true);
      return;
    }
    onSubmit(name.trim());
  };
  return <div className="flex flex-col items-center justify-center min-h-screen px-4 py-12 bg-cream font-sans" data-id="element-24">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="max-w-[500px] w-full flex flex-col items-center text-center" data-id="element-25">
        <p className="text-xs font-bold tracking-[0.15em] text-muted-text uppercase mb-4" data-id="element-26">
          Casi terminamos
        </p>

        <h2 className="font-serif text-3xl md:text-4xl font-bold text-dark-text mb-4 leading-tight" data-id="element-27">
          ¿Cómo te llamas?
        </h2>

        <p className="text-muted-text text-lg mb-8" data-id="element-28">
          Solo necesito tu nombre para generar tu reporte. Sin correo. Sin
          teléfono.
        </p>

        <form onSubmit={handleSubmit} className="w-full flex flex-col gap-4" data-id="element-29">
          <div data-id="element-30">
            <input type="text" value={name} onChange={e => {
            setName(e.target.value);
            setError(false);
          }} placeholder="Tu primer nombre" className={`w-full p-4 rounded-xl border-2 bg-white text-lg outline-none transition-colors ${error ? 'border-red-400 focus:border-red-500' : 'border-transparent focus:border-forest-green shadow-sm'}`} autoFocus data-id="element-31" />
            {error && <p className="text-red-500 text-sm mt-2 text-left" data-id="element-32">
                Por favor ingresa un nombre válido.
              </p>}
          </div>

          <div className="text-left mt-2 mb-2" data-id="element-33">
            <p className="text-sm text-[#555555] flex items-center gap-1.5" data-id="element-34">
              🔒 Esta información no sale de esta página.
            </p>
          </div>

          <button type="submit" className="w-full bg-forest-green text-white py-4 px-6 rounded-xl font-semibold text-[1.1rem] flex items-center justify-center gap-2 hover:bg-[#0f4430] transition-colors shadow-md" data-id="element-35">
            Ver Mi Diagnóstico <ArrowRight className="w-5 h-5" data-id="element-36" />
          </button>
        </form>

        <p className="text-xs text-[#888888] mt-8" data-id="element-37">
          Esta página no es un tratamiento médico.
        </p>
      </motion.div>
    </div>;
};